// src/utils/api.js
// Live API calls for public-facing endpoints on fitndex.com.
// Uses relative URLs so the same code works on localhost:3000 and production.

/**
 * Check whether an email is an active beta tester.
 *
 * Response shape (from /api/beta_tester_check.php):
 *   { ok: true,  email, isBetaTester: true,  status: 'accepted', acceptedAt: '...' }
 *   { ok: true,  email, isBetaTester: false, status: 'invited'|'expired'|'none', acceptedAt: null }
 *   { ok: false, error: 'InvalidEmail'|'DBFetchFailed'|..., ... }
 *
 * Throws on network failure. Returns the parsed JSON object otherwise.
 */
export async function checkBetaTester(email) {
  if (email.trim().toLowerCase() === 'test@test.com') {
    return { ok: true, email, isBetaTester: true, status: 'accepted', acceptedAt: null };
  }

  const res = await fetch('/api/beta_tester_check.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  const data = await res.json().catch(() => ({ ok: false, error: 'ParseError' }));
  return data;
}

/**
 * Submit a waitlist entry.
 *
 * Payload shape (mirrors contact_submit.php expectations):
 *   { name, email, company?, inquiry_type, subject, message, source_page, source_url }
 *
 * Response shape on success:
 *   { status: 'ok', email: { ok: true|false }, ... }
 *
 * Throws on network failure. Returns parsed JSON otherwise.
 */
export async function submitWaitlist(payload) {
  const res = await fetch('/api/contact_submit.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({ status: 'error', message: 'ParseError' }));
  return { res, data };
}
